<template>
    <div id="PageContent"  class="row">
        <side-menu/>
        <div id="InnerContent" class="col col-md-11" :pageType="pageType" :class="{ PowerScanPage: isPowerScan }">
            <div class="row">
                <Breadcrumbs
                :product="currentProduct"
                />
                <PsSiteSelection v-if="(isPowerScan && thisPSPage != 'PickByBin')"/>
            </div>
            <router-view/>
            <PageFooter v-if="!isPowerScan"/>
            <PowerScanPageFooter v-if="isPowerScan"/>
        </div>
    </div>
</template>


<script>
    import SideMenu from '../layout/sidebar/SideMenu.vue'
    import PageFooter from '../layout/footer/PageFooter.vue'
    import Breadcrumbs from '../layout/Breadcrumbs.vue'
    import PowerScanPageFooter from './footer/PowerScanPageFooter'
    import PsSiteSelection from '../layout/header/PsSiteSelection'
    export default {
        name: 'PageContent',
        components: {
            SideMenu,
            PageFooter,
            Breadcrumbs,
            PowerScanPageFooter,
            PsSiteSelection
        },
        computed: {
            pageType() {
                return this.$store.state.pageType
            },
            currentProduct() {
                return this.$store.state.currentProduct
            },
            isPowerScan(){
                return this.$route.path.includes('/power-scan')
            },
            thisPSPage(){
                return this.$route.name
            }
        }
    }
</script>
